import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import socket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { shouldCloseQrModal } from "../../helpers/qrCodeState";

const useStyles = makeStyles((theme) => ({
	dialogContent: {
		padding: theme.spacing(3),
	},
	paper: {
		padding: theme.spacing(0),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	title: {
		textAlign: "center",
		marginBottom: theme.spacing(2)
	},
	qrCodeWrapper: {
		width: "100%",
		maxWidth: 320,
		aspectRatio: "1 / 1",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	qrCode: {
		width: "100%",
		height: "auto",
	},
	waitingText: {
		fontStyle: "italic",
	},
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const classes = useStyles();
	const [qrCode, setQrCode] = useState("");

	useEffect(() => {
		const fetchSession = async () => {
			if (!whatsAppId) return;

			try {
				const { data } = await api.get(`/whatsapp/${whatsAppId}`);
				setQrCode(data.qrcode);
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, [whatsAppId]);

	useEffect(() => {
		if (!whatsAppId) return;
		const handleWhatsAppSession = (data) => {
			if (data.action !== "update" || data.session.id !== whatsAppId) return;

			setQrCode(data.session.qrcode);

			if (shouldCloseQrModal(data.session.status)) {
				onClose();
			}
		};

		socket.on("whatsappSession", handleWhatsAppSession);

		return () => {
			socket.off("whatsappSession", handleWhatsAppSession);
		};
	}, [whatsAppId, onClose]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" scroll="paper" style={{ padding: 0 }}>
			<DialogContent className={classes.dialogContent}>
				<Paper className={classes.paper} elevation={0}>
					<Typography variant="h6" className={classes.title} gutterBottom>
						{i18n.t("qrCode.message")}
					</Typography>
					<div className={classes.qrCodeWrapper}>
						{qrCode ? (
							<QRCode
								value={qrCode}
								renderAs="svg"
								className={classes.qrCode}
							/>
						) : (
							<span className={classes.waitingText}>
								Generando el código QR. Por favor, inténtalo de nuevo en unos segundos.
							</span>
						)}
					</div>
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);
